import * as React from 'react'
import * as API from '../lib/api'
import { PurchaseOption } from '../lib/purchase_option'
import { TaxInformation } from '../lib/tax_information'
import { Testimonials } from '../Testimonials'
import { OrderDetails } from './OrderDetails'

interface IProps {
  currentStepId: string
  // Kept separate from the control checkout's shared `testimonials` so this copy
  // can be edited without touching the A/B control arm.
  checkoutTestimonials: API.ITestimonial[]
  purchaseOptions: PurchaseOption[]
  selectedPurchaseOptionName: API.PurchaseOptionNameType
  onPurchaseOptionChange: (name: API.PurchaseOptionNameType) => void
  taxInformation: TaxInformation
  totals?: API.IOrderTotals
  trial: boolean
  productImagePath?: string
  productImageAlt?: string
}

// Drives the `--stacked` / `--banner` modifier the stylesheet keys its mobile
// layout off; desktop renders both identically.
const STACKED_STEP_IDS = ['payment']

export class RightRail extends React.Component<IProps, object> {
  public render() {
    const { currentStepId } = this.props
    const stacked = STACKED_STEP_IDS.includes(currentStepId)
    const variant = stacked ? 'stacked' : 'banner'

    return (
      <div
        className={`trial-rail__content trial-rail__content--${variant}`}
        data-testid="trial-rail-content"
      >
        {this.renderContent()}
      </div>
    )
  }

  protected renderContent() {
    switch (this.props.currentStepId) {
      case 'account':
        return this.renderTestimonial()
      case 'billing':
        return this.renderImagery()
      case 'payment':
        return this.renderOrderDetails()
      default:
        return null
    }
  }

  // `checkoutTestimonials` already arrives pre-sampled to one entry from Ruby
  // (`presentable_checkout_testimonials.sample(1)`), so `count={1}` is a cap, not a selector.
  protected renderTestimonial() {
    return (
      <div className="trial-rail__testimonial" data-testid="rail-testimonial">
        <Testimonials testimonials={this.props.checkoutTestimonials} count={1} />
      </div>
    )
  }

  protected renderImagery() {
    const { productImagePath, productImageAlt } = this.props

    return (
      <div className="trial-rail__imagery" data-testid="rail-imagery">
        {productImagePath ? (
          <img
            className="trial-rail__imagery-asset"
            src={productImagePath}
            alt={productImageAlt ?? ''}
          />
        ) : (
          <div className="trial-rail__imagery-placeholder" aria-hidden="true" />
        )}
      </div>
    )
  }

  protected renderOrderDetails() {
    const {
      purchaseOptions,
      selectedPurchaseOptionName,
      onPurchaseOptionChange,
      taxInformation,
      totals,
      trial,
    } = this.props

    return (
      <OrderDetails
        purchaseOptions={purchaseOptions}
        selectedPurchaseOptionName={selectedPurchaseOptionName}
        onPurchaseOptionChange={onPurchaseOptionChange}
        taxInformation={taxInformation}
        totals={totals}
        trial={trial}
      />
    )
  }
}
